// import { createStore } from "vuex";
import { createStore } from "vuex";

export default createStore({
    state: {
        currentLanguage: "en",
    },
    mutations: {
        toggleLanguage(state) {
            state.currentLanguage = state.currentLanguage === 'translated' ? 'en' : 'translated';
            localStorage.setItem("currentLanguage", state.currentLanguage);

        },
    },
    actions: {
        toggleLanguage({ commit }) {
            commit('toggleLanguage');
        },
    },
    getters: {
        getCurrentLanguage: (state) => state.currentLanguage,
    },
})